export const theme = {
  primary: "#8d0303",
};
